<template>
  <!-- 
  <v-app>
    <v-main> -->
  <router-view />
  <!-- </v-main>
  </v-app> -->
</template>

<script>
import SessionHelper from "./utils/SessionHelper";
export default {
  name: "App",

  components: {},
  mounted() {
    if (localStorage.getItem("hadToReset") == "true") {
      localStorage.setItem("hadToReset", "false");
      console.debug("CLEARING CACHE"); 
      location.reload(true); 
    } else {
      localStorage.setItem("hadToReset", "true");

      console.debug(" CACHE setted to reset");
    }
    this.$forceUpdate();
  },
  computed: {
    showSidebar() {
      return SessionHelper.checkPermission("SHOW_SIDEBAR");
    },
  },
  data: () => ({
    //
  }),
};
</script>
